import React, { useEffect, useRef } from "react";
import { Navbar, Footer } from "../components";
import { useLocation } from "react-router-dom";


const PoliciesPage = () => {

    const termsRef = useRef(null);
    const privacyRef = useRef(null);
    const refundRef = useRef(null);
    const shippingRef = useRef(null);

    const scrollToSection = (ref) => {
        if (!ref.current) return;

        const navbarHeight = 100; // ↓ You can adjust (80–110) based on your navbar size
        const y =
            ref.current.getBoundingClientRect().top +
            window.pageYOffset -
            navbarHeight;

        window.scrollTo({
            top: y,
            behavior: "smooth",
        });
    };

    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;

        if (hash === "#terms") scrollToSection(termsRef);
        if (hash === "#privacy") scrollToSection(privacyRef);
        if (hash === "#refund") scrollToSection(refundRef);
        if (hash === "#shipping") scrollToSection(shippingRef);
    }, [location]);


    return (
        <>
            <Navbar />

            <div className="container my-4 py-3" style={{ minHeight: "80vh" }}>
                <h1
                    className="text-center"
                    style={{ color: "#198754", fontWeight: 700 }}
                >
                    Policies & Legal Information
                </h1>
                <hr />

                <div className="row mt-4">

                    {/* Sidebar */}
                    <div className="col-md-3">
                        <div className="sidebar-menu">
                            <h5 className="sidebar-title">Policies</h5>

                            <button onClick={() => scrollToSection(termsRef)} className="sidebar-btn">
                                Terms & Conditions
                            </button>

                            <button onClick={() => scrollToSection(privacyRef)} className="sidebar-btn">
                                Privacy Policy
                            </button>

                            <button onClick={() => scrollToSection(refundRef)} className="sidebar-btn">
                                Return & Refund Policy
                            </button>

                            <button onClick={() => scrollToSection(shippingRef)} className="sidebar-btn">
                                Shipping & Payment Policy
                            </button>
                        </div>
                    </div>

                    {/* MAIN CONTENT */}
                    <div className="col-md-9">

                        {/* TERMS */}
                        <section ref={termsRef} className="policy-section">
                            <h3 className="policy-title">📜 Terms & Conditions</h3>

                            <p><strong>Last Updated: 2025</strong></p>

                            <p>
                                Welcome to <strong>VALLALAR NATURALS FROM VILLAGE KANNAMA</strong> ("Company", "we", "our", "us").
                                These Terms & Conditions (“Terms”) govern your use of our website
                                <strong> www.villagekannama.com</strong> (“Website”) and its related services.
                            </p>

                            <p>
                                By accessing or placing an order on this Website, you agree to be bound by these Terms.
                                If you do not agree, please do not use our Website.
                            </p>

                            <h5 className="sub-title">1. General Use</h5>
                            <ul>
                                <li>You must be at least 18 years old to purchase from our Website.</li>
                                <li>We sell natural products and related items.</li>
                                <li>We may modify, update, discontinue, or restrict Website access anytime.</li>
                            </ul>

                            <h5 className="sub-title">2. Product Information</h5>
                            <p>
                                We make every effort to display accurate product descriptions but do not guarantee
                                error-free content. Packaging and colors may vary slightly.
                            </p>

                            <h5 className="sub-title">3. Orders & Acceptance</h5>
                            <p>Placing an order does not guarantee acceptance.</p>
                            <p>Orders are accepted only after successful Razorpay payment.</p>
                            <p>We may cancel orders due to:</p>
                            <ul>
                                <li>Payment failure</li>
                                <li>Incorrect information</li>
                                <li>Product unavailability</li>
                                <li>Suspicious activity</li>
                            </ul>

                            <h5 className="sub-title">4. Pricing</h5>
                            <ul>
                                <li>Prices are listed in INR and may change without notice.</li>
                                <li>The checkout price is final.</li>
                            </ul>

                            <h5 className="sub-title">5. Payments</h5>
                            <p>We accept ONLINE PAYMENT ONLY via Razorpay:</p>
                            <ul>
                                <li>Debit Cards</li>
                                <li>Credit Cards</li>
                                <li>UPI</li>
                                <li>Net Banking</li>
                                <li>Wallets</li>
                            </ul>
                            <p><strong>❌ Cash on Delivery (COD) is NOT available.</strong></p>

                            <p>
                                Payments are securely processed by Razorpay. You agree to their Terms & Privacy Policy.
                            </p>

                            <h5 className="sub-title">6. Shipping</h5>
                            <p>Shipping timelines appear in the Shipping & Payment Policy.</p>

                            <h5 className="sub-title">7. Cancellations / Returns / Refunds</h5>
                            <p><strong>We do NOT accept cancellations, returns, or refunds.</strong></p>

                            <h5 className="sub-title">8. Intellectual Property</h5>
                            <p>
                                All content on this Website is owned by VALLALAR NATURALS FROM VILLAGE KANNAMA.
                                Unauthorized use is prohibited.
                            </p>

                            <h5 className="sub-title">9. Prohibited Activities</h5>
                            <ul>
                                <li>Misuse of Website</li>
                                <li>Uploading harmful files</li>
                                <li>Unauthorized access attempts</li>
                                <li>Illegal activities</li>
                            </ul>

                            <h5 className="sub-title">10. Limitation of Liability</h5>
                            <p>
                                We are not responsible for courier delays, misuse of products, technical issues,
                                or indirect losses. Use of the Website is at your own risk.
                            </p>

                            <h5 className="sub-title">11. Indemnification</h5>
                            <p>
                                You agree to indemnify VALLALAR NATURALS FROM VILLAGE KANNAMA against any claims
                                arising from misuse of our services.
                            </p>

                            <h5 className="sub-title">12. Governing Law</h5>
                            <p>These Terms follow Indian Law. Disputes fall under Tamil Nadu jurisdiction.</p>

                            <h5 className="sub-title">13. Contact Info</h5>
                            <p>
                                VALLALAR NATURALS FROM VILLAGE KANNAMA<br />
                                No. 2, South Street, Abatharanapuram, Serakuppam Post,<br />
                                Vadalur - 607303<br />
                                Email: villagekannamavallalarnaturals@gmail.com<br />
                                Phone: +91 63747 30489
                            </p>
                        </section>

                        {/* PRIVACY POLICY */}
                        <section ref={privacyRef} className="policy-section">
                            <h3 className="policy-title">🔐 Privacy Policy</h3>

                            <p><strong>Last Updated: 2025</strong></p>

                            <p>
                                We value your privacy. This Policy explains how we collect, use, store, and protect your
                                data when visiting <strong>www.villagekannama.com</strong>.
                            </p>

                            <h5 className="sub-title">1. Information We Collect</h5>

                            <p><strong>a) Personal Information</strong></p>
                            <ul>
                                <li>Name</li>
                                <li>Address</li>
                                <li>Email</li>
                                <li>Phone number</li>
                                <li>Payment details (processed securely by Razorpay)</li>
                            </ul>

                            <p><strong>b) Non-Personal Information</strong></p>
                            <ul>
                                <li>Browser details</li>
                                <li>Device info</li>
                                <li>IP address</li>
                                <li>Cookies & usage patterns</li>
                            </ul>

                            <h5 className="sub-title">2. How We Use Your Information</h5>
                            <ul>
                                <li>To process and deliver orders</li>
                                <li>To provide customer support</li>
                                <li>To prevent fraud</li>
                                <li>To improve our website</li>
                                <li>To send essential updates</li>
                            </ul>

                            <p><strong>We do NOT sell your data.</strong></p>

                            <h5 className="sub-title">3. Payments via Razorpay</h5>
                            <p>Your payment details are not stored by us. Razorpay handles all financial data.</p>

                            <h5 className="sub-title">4. Cookies</h5>
                            <p>Cookies help improve functionality and analytics.</p>

                            <h5 className="sub-title">5. Information Sharing</h5>
                            <ul>
                                <li>Courier partners</li>
                                <li>Razorpay</li>
                                <li>Legal authorities</li>
                            </ul>

                            <h5 className="sub-title">6. Data Security</h5>
                            <p>
                                We use industry-level protection but cannot guarantee 100% safety due to internet risks.
                            </p>

                            <h5 className="sub-title">7. Data Retention</h5>
                            <p>
                                We retain your data only as required for legal, transactional, and service reasons.
                            </p>

                            <h5 className="sub-title">8. Your Rights</h5>
                            <ul>
                                <li>Request data correction</li>
                                <li>Request deletion (where legally possible)</li>
                                <li>Opt-out of emails</li>
                            </ul>

                            <h5 className="sub-title">9. External Links</h5>
                            <p>
                                We are not responsible for content or privacy practices of third-party websites.
                            </p>

                            <h5 className="sub-title">10. Changes</h5>
                            <p>
                                We may update this policy anytime. Updates appear on this page.
                            </p>

                            <h5 className="sub-title">11. Grievance Officer</h5>
                            <p>
                                Email: villagekannamavallalarnaturals@gmail.com<br />
                                Phone: +91 63747 30489
                            </p>
                        </section>

                        {/* REFUND SECTION */}
                        <section ref={refundRef} className="policy-section">
                            <h3 className="policy-title">❌ Return & Refund Policy</h3>

                            <p><strong>Last Updated: 2025</strong></p>

                            <p>
                                At <strong>Vallalar Naturals – Village Kannama</strong>, we take great care in
                                preparing and delivering 100% natural, fresh, and handmade products.
                                Due to the nature of our products, we follow a strict
                                <strong> no return, no exchange, and no refund policy</strong>.
                            </p>

                            <h5 className="sub-title">No Return or Exchange Policy</h5>
                            <p>
                                All products sold on <strong>www.villagekannama.com</strong> are
                                <strong> non-returnable and non-exchangeable</strong>. Once an order has been
                                delivered, we cannot accept returns or exchanges, as we cannot guarantee
                                product quality, safety, or hygiene after delivery.
                            </p>

                            <h5 className="sub-title">Damaged, Defective, or Wrong Item Received</h5>
                            <p>
                                In the rare event that you receive a product that is damaged, leaked,
                                defective, or incorrect, please contact us within
                                <strong> 24 hours of delivery</strong> by emailing:
                            </p>

                            <p>
                                <strong>villagekannamavallalarnaturals@gmail.com</strong>
                            </p>

                            <p>Please include the following details in your email:</p>
                            <ul>
                                <li>Your Order ID</li>
                                <li>Clear photos of the product and outer packaging</li>
                                <li>Unboxing video (if available)</li>
                            </ul>

                            <p>
                                After verification of the issue, we may:
                            </p>
                            <ul>
                                <li>Arrange a replacement for the same product, or</li>
                                <li>Initiate a refund if a replacement is unavailable</li>
                            </ul>

                            <p>
                                Refunds or replacements will only be processed for valid and verified
                                cases of damaged or incorrect items.
                            </p>

                            <h5 className="sub-title">Non-Returnable Items</h5>
                            <p>The following items are strictly non-returnable and non-refundable:</p>
                            <ul>
                                <li>All edible products, natural powders, oils, soaps, and personal care items</li>
                                <li>Opened, unsealed, or used products</li>
                                <li>Items returned without prior communication or approval</li>
                                <li>Products damaged due to improper storage or handling by the customer</li>
                            </ul>

                            <h5 className="sub-title">Order Cancellation</h5>
                            <p>
                                Orders can be cancelled only within
                                <strong> 1 hour of placing the order</strong>, provided the order has not yet
                                been packed or shipped.
                            </p>

                            <p>
                                To request a cancellation, please email us immediately with your Order ID
                                at:
                            </p>

                            <p>
                                <strong>villagekannamavallalarnaturals@gmail.com</strong>
                            </p>

                            <p>
                                Once an order has been processed or shipped, it cannot be cancelled,
                                returned, or refunded.
                            </p>
                        </section>


                        {/* SHIPPING SECTION */}
                        <section ref={shippingRef} className="policy-section">
                            <h3 className="policy-title">🚚 Shipping & Payment Policy</h3>

                            <p><strong>Last Updated: 2025</strong></p>

                            <h5 className="sub-title">1. Shipping Timeline</h5>
                            <p>
                                Orders are shipped within <strong>24-48 hours.</strong>Delivery time: <strong>2–7 business days</strong>.
                            </p>

                            <h5 className="sub-title">2. Delivery Coverage</h5>
                            <p>We ship PAN-India via trusted courier partners.</p>

                            <h5 className="sub-title">3. Shipping Charges</h5>
                            <p>Charges are shown at checkout. Some products may include free shipping.</p>

                            <h5 className="sub-title">4. Order Tracking</h5>
                            <p>You will receive updates + tracking link once dispatched.</p>

                            <h5 className="sub-title">5. Delivery Confirmation</h5>
                            <p>
                                A signature/OTP may be required. After confirmation, responsibility transfers to you.
                            </p>

                            <h5 className="sub-title">6. Payment Methods</h5>
                            <p>We accept the following via Razorpay:</p>
                            <ul>
                                <li>UPI</li>
                                <li>Debit Cards</li>
                                {/* <li>Credit Cards</li>
                                <li>Net Banking</li>
                                <li>Wallets</li> */}
                            </ul>

                            <p><strong>❌ Cash on Delivery is NOT available.</strong></p>
                        </section>


                    </div>
                </div>
            </div>

            <Footer />

            {/* Styles */}
            <style>{`
        .sidebar-menu {
          background: #f9f9f2;
          border: 1px solid #cfead9;
          padding: 15px;
          border-radius: 12px;
        }
        .sidebar-title {
          color: #198754;
          font-weight: 700;
          margin-bottom: 10px;
        }
        .sidebar-btn {
          width: 100%;
          background: #ffffff;
          border: 1px solid #198754;
          color: #198754;
          padding: 10px;
          border-radius: 8px;
          font-weight: 600;
          margin-bottom: 10px;
          cursor: pointer;
          transition: 0.3s ease;
        }
        .sidebar-btn:hover {
          background: #198754;
          color: #fff;
        }
        .policy-section {
          background: #f9f9f2;
          border: 1px solid #cfead9;
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 25px;
        }
        .policy-title {
          color: #198754;
          font-weight: 700;
          margin-bottom: 10px;
        }
        .sub-title {
          color: #198754;
          font-weight: 600;
          margin-top: 15px;
        }
        ul {
          padding-left: 20px;
        }
        .btn-back-home {
          background: #198754;
          color: #fff;
          padding: 10px 22px;
          border-radius: 8px;
          font-weight: 600;
          border: none;
          cursor: pointer;
        }
        .btn-back-home:hover {
          background: #156c45;
        }
      `}</style>
        </>
    );
};

export default PoliciesPage;
